<template>
  <w-modal
    v-model="show"
    submit-button="Zamknij"
    title="Podgląd dokumentu"
    size="fullscreen"
    :show-close-button="false"
    :close-on-submit="false"
    :hide-on-overlay="false"
    :hide-on-esc="false"
    @submit="close"
    @close="close"
  >
    <iframe class="iframe" :srcdoc="html" />

    <div slot="footer">
      <w-button class="btn btn-secondary float-left" text="Zamknij" @click="close" />

      <w-button v-if="showEditButton" class="btn btn-primary float-right" text="Edytuj" @click="editHTML" />
    </div>
  </w-modal>
</template>

<script>
import { modalMixin } from '@/mixins/modal';

// @vuese
// Modal podglądu
// @group Modals
export default {
  name: 'PreviewModal',
  mixins: [modalMixin],
  props: {
    // HTML do wyświetlenia w iframe
    html: {
      type: String,
      required: false
    },
    // Czy wyświetlić przycisk edycji?
    showEditButton: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    // @vuese
    // Emitowanie htmla do edycji
    editHTML() {
      this.$emit('editHTML');
    }
  }
};
</script>

<style>
.modal-body > .iframe {
  border: none;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: absolute;
  width: 100%;
  height: 100%;
}
</style>
